export const normalize = text => String(text).trim().toLowerCase().replace(' ', '-')
